import { render, staticRenderFns } from "./AddOrUpdate.vue?vue&type=template&id=624c24e2&scoped=true"
import script from "./AddOrUpdate.vue?vue&type=script&lang=js"
export * from "./AddOrUpdate.vue?vue&type=script&lang=js"
import style0 from "./AddOrUpdate.vue?vue&type=style&index=0&id=624c24e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "624c24e2",
  null
  
)

export default component.exports